<kendo-dialog-titlebar (close)="fecheModal()">
  <h4 class="modal-title">
    <i class="fa fa-download fa-lg mr-1"></i>Exportar insumos
  </h4>
</kendo-dialog-titlebar>

<div class="modal-body">
  <h5>
    Total de insumos e fichas encontrados: <b>{{insumos.length}}</b>
  </h5>
  <p class="text-muted">
    Ao selecionar uma ficha técnica, todos os ingredientes da composição são selecionados
    automaticamente. Ingredientes obrigatórios não podem ser desmarcados enquanto a ficha estiver selecionada.
    Saldo, custos, vínculos e unidades de compra não são transferidos.
  </p>

  <div class="alert alert-danger" *ngIf="mensagemErro">
    <i class="mdi mdi-alert-circle-outline mr-1"></i>{{mensagemErro}}
  </div>

  <kendo-grid kendoGridSelectBy="id"
              style="min-height: 350px"
              [kendoGridBinding]="insumos"
              [selectable]="{mode: 'multiple', drag: false, checkboxOnly: true}"
              [filterable]="'menu'"
              [(selectedKeys)]="insumosSelecionadosIds"
              (selectedKeysChange)="onSelectedKeysChange($event)"
              [loading]="carregando"
              [class]="'gridProdutos'">
    <kendo-grid-messages
      noRecords="Sem insumos"
      loading="Carregando"
      filter="Filtrar"
      filterInputLabel="Filtro para {columnName}"
      filterMenuTitle="Filtrar {columnName}"
      filterMenuOperatorsDropDownLabel="Operador do filtro para {columnName}"
      filterMenuLogicDropDownLabel="Lógica do filtro para {columnName}"
      filterEqOperator="É igual a"
      filterNotEqOperator="É diferente de"
      filterIsNullOperator="É nulo"
      filterIsNotNullOperator="Não é nulo"
      filterIsEmptyOperator="Está vazio"
      filterIsNotEmptyOperator="Não está vazio"
      filterStartsWithOperator="Começa com"
      filterContainsOperator="Contém"
      filterNotContainsOperator="Não contém"
      filterEndsWithOperator="Termina com"
      filterGteOperator="É maior ou igual a"
      filterGtOperator="É maior que"
      filterLteOperator="É menor ou igual a"
      filterLtOperator="É menor que"
      filterIsTrue="Sim"
      filterIsFalse="Não"
      filterBooleanAll="(Todos)"
      filterAfterOrEqualOperator="É posterior ou igual a"
      filterAfterOperator="É posterior a"
      filterBeforeOperator="É anterior a"
      filterBeforeOrEqualOperator="É anterior ou igual a"
      filterFilterButton="Filtrar"
      filterClearButton="Limpar"
      filterAndLogic="E"
      filterOrLogic="Ou">
    </kendo-grid-messages>

    <ng-template kendoGridToolbarTemplate>
      <button type="button" class="btn btn-outline-secondary btn-sm"
              (click)="exporte()"
              [disabled]="!insumosSelecionadosIds.length || exportando || mensagemErro">
        <i class="k-icon k-i-loading mr-1" *ngIf="exportando"></i>
        <i class="fa fa-download mr-1" *ngIf="!exportando"></i>
        {{exportando ? 'Exportando...' : 'Exportar selecionados'}}
      </button>
      <span class="ml-2 text-muted">
        {{insumosSelecionadosIds.length}} selecionado(s)
      </span>
    </ng-template>

    <kendo-grid-checkbox-column [width]="50">
      <ng-template kendoGridHeaderTemplate>
        <input type="checkbox"
               class="k-checkbox k-checkbox-md k-rounded-md"
               aria-label="Selecionar todas as linhas"
               title="Selecionar todas as linhas"
               [checked]="todasLinhasSelecionadas()"
               [indeterminate]="selecaoParcial()"
               [disabled]="carregando || !insumos.length"
               (change)="altereSelecaoTodasLinhas($event)">
      </ng-template>
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
        <input type="checkbox" class="k-checkbox k-checkbox-md k-rounded-md"
               [kendoGridSelectionCheckbox]="rowIndex"
               [disabled]="ingredienteObrigatorio(dataItem.id)"
               [attr.title]="ingredienteObrigatorio(dataItem.id) ? 'Obrigatório para uma ficha técnica selecionada' : null">
      </ng-template>
    </kendo-grid-checkbox-column>

    <kendo-grid-column title="Tipo" [width]="155">
      <ng-template kendoGridCellTemplate let-insumo>
        <span class="tipo-item" [class.tipo-ficha]="insumo.objeto === 'ficha-tecnica'">
          <i class="mdi" [ngClass]="insumo.objeto === 'ficha-tecnica' ? 'mdi-clipboard-text-outline' : 'mdi-package-variant'"></i>
          {{descricaoTipo(insumo)}}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Código" field="codigo" [width]="130">
      <ng-template kendoGridCellTemplate let-insumo>
        <span class="text-blue"><b>{{insumo.codigo || '-'}}</b></span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Grupo" field="grupo.nome" [width]="190">
      <ng-template kendoGridCellTemplate let-insumo>
        <span>{{insumo.grupo?.nome || 'Sem grupo'}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Insumo" field="nome">
      <ng-template kendoGridCellTemplate let-insumo>
        <span class="text-blue"><b>{{insumo.nome}}</b></span>
        <i *ngIf="ingredienteObrigatorio(insumo.id)"
           class="mdi mdi-lock-outline ingrediente-obrigatorio ml-1"
           kendoTooltip title="Obrigatório para uma ficha técnica selecionada"></i>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Unidade-base" field="unidadeMedida.sigla" [width]="145">
      <ng-template kendoGridCellTemplate let-insumo>
        <b>{{insumo.unidadeMedida?.sigla || '-'}}</b>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Estoque mínimo" field="estoque.quantidadeMinima" [width]="150">
      <ng-template kendoGridCellTemplate let-insumo>
        {{insumo.estoque?.quantidadeMinima == null ? 0 : insumo.estoque.quantidadeMinima}}
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
